var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wifi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Intersect"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3847 6.11539C15.5957 5.90438 15.5785 5.554 15.337 5.37866C13.2765 3.8824 10.7413 3 8.00008 3C5.25882 3 2.72366 3.8824 0.663135 5.37866C0.421664 5.554 0.404458 5.90438 0.615473 6.11539C0.794016 6.29394 1.07854 6.31191 1.28338 6.16428C3.17305 4.80234 5.49286 4 8.00008 4C10.5073 4 12.8271 4.80234 14.7168 6.16428C14.9216 6.31191 15.2061 6.29394 15.3847 6.11539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2291 8.27103C13.4452 8.05492 13.4226 7.69262 13.1663 7.52619C11.6792 6.56075 9.90513 6 8.00008 6C6.09502 6 4.32094 6.56075 2.83387 7.52619C2.57753 7.69262 2.55499 8.05492 2.77111 8.27103C2.94378 8.44371 3.21779 8.46769 3.42346 8.33603C4.74456 7.49031 6.31506 7 8.00008 7C9.6851 7 11.2556 7.4903 12.5767 8.33603C12.7824 8.46769 13.0564 8.44371 13.2291 8.27103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0462 10.4539C11.2723 10.2278 11.2309 9.84946 10.946 9.70432C10.0616 9.25394 9.06051 9 8.00008 9C6.93965 9 5.93852 9.25394 5.05421 9.70432C4.76923 9.84946 4.72786 10.2278 4.954 10.4539L4.96903 10.469C5.12941 10.6293 5.37664 10.6595 5.58026 10.5595C6.31048 10.2012 7.13178 10 8.00008 10C8.86837 10 9.68968 10.2012 10.4199 10.5595C10.6235 10.6595 10.8707 10.6293 11.0311 10.469L11.0462 10.4539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06074 12.4393C9.256 12.2441 9.25799 11.9207 9.02063 11.7796C8.72186 11.602 8.37288 11.5 8.00008 11.5C7.62728 11.5 7.2783 11.602 6.97953 11.7796C6.74217 11.9207 6.74416 12.2441 6.93942 12.4393L7.64653 13.1464C7.84179 13.3417 8.15837 13.3417 8.35363 13.1464L9.06074 12.4393Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.131f0078059cba6b673aedcc94a354db.svg";
export { ForwardRef as ReactComponent };